export default "__VITE_ASSET__befdecc2__"